import React from 'react';
import EducationalImagesTagFilter from './filters/EducationalImagesTagFilter';
import EducationalImagesPeriodFilter from './filters/EducationalImagesPeriodFilter';
import EducationalImagesCountyFilter from './filters/EducationalImagesCountyFilter';
import EducationalImagesDistrictFilter from './filters/EducationalImagesDistrictFilter';

export default function EducationalImagesSearchFilters() {
  return (
    <>
      <EducationalImagesTagFilter />
      <EducationalImagesPeriodFilter />
      <EducationalImagesCountyFilter />
      <EducationalImagesDistrictFilter />
    </>
  );
}
